module.exports = __webpack_public_path__ + "static/media/torch.c8c01192.png";